namespace cdh {

    // #region Knockout Bindings


    let r = /^[ ]*$/;

    /**
     * converts the value into a moment, also shows whether the conversion was was successfull
     * @param value value to convert
     * @param invariant whether the value should be assumed to be an invariant String or a user input.
     * @returns the first item shows whether the conversion was successful, the second item contains the converted value, if the value is null or empty true and null will be returned.
     */
    function getMoment(value: string | moment.Moment | Date, invariant: boolean): [boolean, moment.Moment] {
        let m: moment.Moment;
        let success = true;

        if (value === null)
            m = null;
        else if (value instanceof moment) {
            m = <moment.Moment>value;

            m.locale(localization.locales.findItem(localization.locale()).culture);
        }
        else if (value instanceof Date)
            m = moment(value);
        else if (typeof (value) === "string") {
            if (r.test(value))
                m = null;
            if (invariant)
                m = moment(value);
            else {
                m = moment(value, "L");
                if (!m.isValid()) {
                    m = moment.utc(value);
                    if (!m.isValid)
                        success = false;
                    else
                        m = m.local();
                }
            }
        }

        return [success, m];
    }

    /**
     * converts the value into a timespan, also shows whether the conversion was was successfull
     * @param value value to convert
     * @param invariant whether the value should be assumed to be an invariant String or a user input.
     * @returns the first item shows whether the conversion was successful, the second item contains the converted value, if the value is null or empty true and null will be returned.
     */
    function getTimespan(value: string | moment.Duration): [boolean, moment.Duration] {
        let m: moment.Duration;
        let success = true;

        if (value === null)
            m = null;

        else if (moment.isDuration(value))
            m = value;
        else if (typeof (value) === "string") {
            if (r.test(value))
                m = null;
            else {
                m = moment.duration(value);
            }
        }

        return [success, m];
    }


    function extendDate(target: KnockoutObservable<any>, mode?: "date"): KnockoutDateExtender;
    function extendDate(target: KnockoutObservable<any>, mode: "dateTime"): KnockoutDatetimeExtender;
    function extendDate(target: KnockoutObservable<any>, mode?: "date" | "dateTime"): KnockoutDateExtender | KnockoutDatetimeExtender {

        if (!mode) mode = "date";

        var val = ko.unwrap(target);
        let tar: KnockoutObservable<moment.Moment> = ko.isWriteableObservable(target) ? target : ko.observable();

        //if (typeof val === "string")
        //    tar(moment(val));
        var tmp = getMoment(val, true);
        tar(tmp[0] ? tmp[1] : null);

        let hasError = ko.observable(false);

        let value = ko.pureComputed<moment.Moment>({
            read: function () {
                let date = target();
                localization.locale(); // Get a Dependency on the Locale so the Binding is Updated when it changes

                let result = getMoment(date, true);

                return result[0] ? result[1] : null;
            },
            write: function (value: string | moment.Moment | Date) {
                let result = getMoment(value, true);

                hasError(!result[0]);
                target(result[0] ? result[1] : null);
            }
        });

        let result: any = ko.pureComputed<string>(
            {
                read: function () {
                    let date = value();

                    if (date)
                        return date.format("L");
                    else
                        return null;
                },
                write: write
            });

        let state: KnockoutDateExtenderState = {
            value: value,
            date: function (): string {
                let m = value();

                if (!(m instanceof moment && m.isValid()))
                    return null;
                else
                    return m.toISOString();

            },
            dateObj: ko.pureComputed<Date>({
                read: () => {
                    let m = value();

                    if (m != null)
                        return m.toDate();
                    else
                        return null;
                }, write: write
            }),
            hasError: hasError
        };

        result.state = function () { return state };
        if (utils.equalsIgnoreCase(mode, "dateTime")) {
            let tarDate = ko.pureComputed({
                read: () => {
                    var tarM = tar();
                    if (moment.isMoment(tarM) && tarM.isValid())
                        return tarM.clone().startOf("day");

                    return null;
                },
                write(val) {
                    if (val)
                        updateTarget(val, tarTime());
                    else
                        value(null);
                }
            });
            let tarTime = ko.pureComputed({
                read: () => {
                    var tarM = tar();
                    if (moment.isMoment(tarM) && tarM.isValid())
                        return tarM.clone();

                    return null;
                },
                write(val) {
                    if (val)
                        updateTarget(tarDate(), val);
                    else
                        value(null);

                }
            });


            result.date = createComponent(tarDate);
            result.time = createComponent(tarTime);

            return <KnockoutDatetimeExtender>result;

        }


        return <KnockoutDateExtender>result;



        function write(value: string | moment.Moment | Date) {
            let result = getMoment(value, false);

            hasError(!result[0]);
            target(result[0] ? result[1] : null);
        };

        function updateTarget(mDate: moment.Moment, mTime: moment.Moment) {
            let res: moment.Moment = null;

            if (moment.isMoment(mDate) && mDate.isValid) {
                res = mDate.clone();
                if (moment.isMoment(mTime) && mTime.isValid()) {
                    res.set({
                        hour: mTime.get("hour"),
                        minute: mTime.get("minute"),
                        second: mTime.get("second"),
                    });
                }

            }
            else if (moment.isMoment(mTime) && mTime.isValid()) {
                res = moment();

                res.set({
                    hour: mTime.get("hour"),
                    minute: mTime.get("minute"),
                    second: mTime.get("second"),
                });
            }

            tar(res);
        }

        function createComponent(tarCmp: KnockoutObservable<moment.Moment>): KnockoutDatetimeExtenderComponent {

            return {
                date: ko.pureComputed({
                    read() {
                        var m = tarCmp();
                        return moment.isMoment(m) && m.isValid() ? m.toDate() : null;
                    },
                    write(val) {
                        tarCmp(moment.isDate(val) ? moment(val) : null);
                    }
                }),
                value: tarCmp
            };

        }
    }

    ko.extenders.date = extendDate;

    ko.extenders.datetime = function (target: KnockoutObservable<any>) {
        return extendDate(target, "dateTime");
    }
    export function dateObservable(time?: false): KnockoutDateExtender;
    export function dateObservable(time: true): KnockoutDatetimeExtender;
    export function dateObservable(time: boolean) {
        if (time !== true)
            return extendDate(ko.observable(), "date")
        else
            return extendDate(ko.observable(), "dateTime");
    }

    ko.extenders.timeSpan = function (target: KnockoutObservable<any>) {


        if (typeof target() === "string")
            target(moment.duration(target()));

        let hasError = ko.observable(false);


        let value = ko.pureComputed<moment.Duration>({
            read: function () {
                let date = target();
                localization.locale(); // Get a Dependency on the Locale so the Binding is Updated when it changes

                let result = getTimespan(date);

                return result[0] ? result[1] : null;
            },
            write: function (value: string | moment.Duration) {
                let result = getTimespan(value);

                hasError(!result[0]);
                target(result[0] ? result[1] : null);
            }
        });

        let result: any = ko.pureComputed<string>(
            {
                read: function () {
                    let date = value();

                    if (date)
                        return date.toISOString();
                    else
                        return null;

                },
                write: value
            });

        let state: KnockoutTimeSpanExtenderState = {
            value: value,
            timeSpan: function (): string {
                let m = value();

                if (!(moment.isDuration(m)))
                    return null;
                else
                    return m.toISOString();

            },
            hasError: hasError
        };

        result.state = function () { return state };

        return <KnockoutTimeSpanExtender>result;
    }

    ko.extenders.numeric = function (target, decimals) {

        if (!decimals)
            decimals = 0;

        let hasError = ko.observable(false);
        let state: KnockoutValidationExtenderState = { hasError };

        let roundingMultiplier = Math.pow(10, decimals);
        //create a writable computed observable to intercept writes to our observable
        var result: KnockoutComputed<number> & Partial<KnockoutValidationExtender<number>> = ko.pureComputed<number>({
            read: target,  //always return the original observables value
            write: function (newValue) {
                var current = target(), valueToWrite;

                let err = false;

                if (newValue === null || newValue === undefined || (typeof newValue === "string" && newValue == "")) {
                    valueToWrite = null;
                }
                else if (isNaN(newValue)) {
                    valueToWrite = current;
                    err = true;
                }
                else {
                    let newValueAsNum = +newValue;
                    valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;
                }

                hasError(err);

                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    //if the rounded value is the same, but a different value was written, force a notification for the current field
                    if (newValue !== current && !err) {
                        target.notifySubscribers(valueToWrite);
                    }
                }
            }

        }).extend({ notify: "always" });

        result.state = () => state;

        //initialize with current value to make sure it is rounded appropriately
        result(target());

        //return the new computed observable
        return <KnockoutValidationExtender<number>>result;
    }

    ko.extenders.enum = function <TEnum>(target: KnockoutObservable<TEnum>, type: { [name: string]: TEnum }) {

        let vals: { name: string, value: TEnum }[] = [];
        $.each(type, (pn, pv) => vals.push({ name: String(pn), value: pv }));


        let hasError = ko.observable(false);
        let state: KnockoutValidationExtenderState = { hasError };

        //create a writable computed observable to intercept writes to our observable
        var result: KnockoutComputed<TEnum> & Partial<KnockoutValidationExtender<TEnum>> = ko.pureComputed<TEnum>({
            read: target,  //always return the original observables value
            write: function (newValue) {
                var current = target();
                var valueToWrite: TEnum;
                var err = false;
                var val = vals.find(v => v.value == newValue || (typeof newValue === "string" && utils.equalsIgnoreCase(v.name, newValue)))

                if (val) {
                    valueToWrite = val.value;
                }
                else if (newValue === null || newValue === undefined || (typeof newValue === "string" && newValue === "")) {
                    valueToWrite = null;
                }
                else {
                    valueToWrite = current
                    err = true;
                }

                hasError(err);
                //only write if it changed
                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    //if the rounded value is the same, but a different value was written, force a notification for the current field
                    if (newValue !== current && !err) {
                        target.notifySubscribers(valueToWrite);
                    }
                }
            }

        }).extend({ notify: "always" });

        result.state = () => state;

        //initialize with current value to make sure it is rounded appropriately
        result(target());

        //return the new computed observable
        return <KnockoutValidationExtender<TEnum>>result;
    }

    ko.extenders.temporaryItems = function <TItem>(target: KnockoutObservable<TItem[]>) {

        var tmpItems = ko.observableArray<TItem>();

        var mergedResult: any = ko.pureComputed(() => {
            var items: TItem[] = [];

            var tmp = ko.unwrap(tmpItems);
            if ($.isArray(tmp))
                items.push(...tmp);

            var tmp2 = ko.unwrap(target);
            if (tmp2) {
                $.each(tmp2, (i, v) => {
                    items.push(v);
                });
            }

            return items;
        });

        mergedResult.source = target;
        mergedResult.temporaryItems = tmpItems;

        return mergedResult as KnockoutTemporaryItemExtender<TItem>;
    }

    var dictionaryExtender = function <T>(target: KnockoutObservable<T[]>, options: keyof T | { (item: T): string } | DictionaryOptions<T>) {

        let o: DictionaryOptions<T>;

        if (!options)
            o = { key: i => i != null ? i.toString() : "" };
        else if (typeof (options) === "string" || typeof (options) === "number" || typeof (options) === "function")
            o = <DictionaryOptions<T>>{ key: options };
        else
            o = options as DictionaryOptions<T>;


        let r: KnockoutDictionaryExtender<T>;

        if (o.isReadOnly)
            r = <any>ko.pureComputed(() => target());
        else
            r = <KnockoutDictionaryExtender<T>>target;

        let keyDef = o.key;
        let keyAcc: (item: T) => string;

        if (typeof (keyDef) === "function")
            keyAcc = keyDef as (item: T) => string;
        else
            keyAcc = (item: T) => ko.unwrap(item[keyDef as keyof T] as any);

        let lookup2 = ko.pureComputed(() => {
            let result: { [code: string]: T } = {};
            let arr = ko.unwrap(target);

            if ($.isArray(arr))
                ko.utils.arrayForEach(arr, (item, index) => {
                    let k: string = null;

                    k = keyAcc(item);

                    if (k)
                        result[k.toString().toUpperCase()] = item;
                });

            return result;
        });

        var findItem = (code: string | KnockoutObservable<string>) => {

            if (ko.isObservable(code))
                code = ko.unwrap(code);

            if (!code)
                return null;

            code = String(code).toUpperCase();

            return lookup2()[code];
        }

        r.findItem = findItem;

        return r;
    }

    export function createDictionary<T>(target: KnockoutObservable<T[]>, options: keyof T | { (item: T): string } | DictionaryOptions<T>): KnockoutDictionaryExtender<T> {
        return dictionaryExtender(target, options);
    }

    export function createNewDictionary<T>(key: keyof T): KnockoutDictionaryExtender<T>;
    export function createNewDictionary<T>(func: { (item: T): string }): KnockoutDictionaryExtender<T>;
    export function createNewDictionary<T>(options: DictionaryOptions<T>): KnockoutDictionaryExtender<T>;
    export function createNewDictionary<T>(options: keyof T | { (item: T): string } | DictionaryOptions<T>): KnockoutDictionaryExtender<T> {
        return dictionaryExtender(ko.observable<T[]>([]), options);
    }

    ko.observableArray.fn.toDictionary = function (options) { return dictionaryExtender(this, options); };



    ko.extenders.resolvePromise = function <T>(target: KnockoutObservable<T>, options?: { (reason: any): void }) {

        let state = new utils.AsyncComputedInternalState(target);
        state.onError = options;

        let result: Mutable<Partial<KnockoutResolvePromiseExtender<T>>> = ko.pureComputed<T>({
            read: target,
            write: function (value: T | PromiseLike<T>) {
                state.setResult(value);
            }
        });

        result.isLoading = state.isLoading;
        result.awaitResult = state.awaitResult;

        return result as KnockoutResolvePromiseExtender<T>;
    }

    // #endregion

    const basePath = Router ? Router.baseUrl : "/";

    /** Functions and Types related to localization */
    export namespace localization {
        export type languageDef = { locale: string, culture: string };
        type languageDefInternal = languageDef & { isLoaded?: boolean }

        export interface ILocalizationOptions {
            cultureCookieName?: string,
            locales: languageDef[],
            cldrDataPath: string,
        };

        let _cultureCookieName = "cdh.culture";
        let _cldrDataPath = basePath + "vendor/cldr-data/";

        let _locale = ko.observable<string>(null);
        let _locales = ko.observableArray<languageDefInternal>([
            { locale: "de", culture: "de-DE" },
            { locale: "en", culture: "en-US" },
            { locale: "fr", culture: "fr-FR" }]);

        type MessageDefinition = { name: string, type?: "default" | "api" }

        let _messages: MessageDefinition[] = [{ name: "all", type: "api" }];
        let _globalizeInitMain: PromiseLike<any>;
        let _globalizeInitMsg: PromiseLike<any>;
        let _globalizeChanged = ko.observable<Globalize.Static>(Globalize);
        type localizationErrors = { [key: string]: any };
        let errors: localizationErrors = {};

        export var globalize = ko.pureComputed<Globalize.Static>({ read: _globalizeChanged });

        function getMessageDefinition(raw: string | MessageDefinition) {
            let res: MessageDefinition = null;

            if (typeof raw == "string")
                res = { name: raw };
            else if (typeof raw == "object" && typeof raw.name == "string")
                res = raw;

            if (res && res.name)
                return res;
            else
                return null;
        }

        function msgName(msg: MessageDefinition) {
            return (msg.type || "default") + ":" + msg.name;
        }
        function findMessage(msg1: MessageDefinition) {
            let msg1Name = msgName(msg1);
            return (msg2: MessageDefinition) => utils.equalsIgnoreCase(msg1Name, msgName(msg2));
        }

        // #region Initialization/Loading

        function getUrlForSupplemental(name: string) {
            return _cldrDataPath + "supplemental/" + name + ".json";
        }
        function getUrlForMain(locale: string, name: string) {
            return _cldrDataPath + "main/" + locale + "/" + name + ".json";
        }

        function globalizeLoadSupplementals() {
            return utils.allWithFails(
                $.getJSON(getUrlForSupplemental("likelySubtags")),
                $.getJSON(getUrlForSupplemental("timeData")),
                $.getJSON(getUrlForSupplemental("currencyData")),
                $.getJSON(getUrlForSupplemental("numberingSystems")),
                $.getJSON(getUrlForSupplemental("weekData")),
                $.getJSON(getUrlForSupplemental("plurals")),
                $.getJSON(getUrlForSupplemental("ordinals")),
            ).then(Globalize.load)
        }

        async function globalizeLoadMain(locale: string) {
            var resArr = await utils.allWithFails(
                $.getJSON(getUrlForMain(locale, "numbers")),
                $.getJSON(getUrlForMain(locale, "currencies")),
                $.getJSON(getUrlForMain(locale, "ca-gregorian")),
                $.getJSON(getUrlForMain(locale, "timeZoneNames")),
            );

            Globalize.load(resArr);
        }

        async function loadLanguage(langs: languageDef[]) {
            if (!langs || langs.length == 0) return;

            for (var i = 0; i < langs.length; i++) {
                await globalizeLoadMain(langs[i].locale);
            }

            await loadMessagesForLang(langs);
        }

        /**
         * Initializes the localization Framework (globalize)
         * @param cfg
         */
        export function initGlobalize(cfg: ILocalizationOptions) {


            if (_globalizeInitMain)
                return _globalizeInitMsg;

            if (cfg.cultureCookieName)
                _cultureCookieName = cfg.cultureCookieName;
            if (cfg.cldrDataPath) {
                if (cfg.cldrDataPath.substr(0, 2) == "~/")
                    _cldrDataPath = basePath + cfg.cldrDataPath.substr(2);
                else
                    _cldrDataPath = cfg.cldrDataPath;
            }

            if (cfg.locales)
                _locales(cfg.locales);

            $("[data-lang-req-name]").each((i, e) => {
                includeMessages($(e).data("lang-req-name"));
            });


            let culture = cdh.utils.getCultureFromCookie(_cultureCookieName);
            let loc: languageDefInternal;
            let loadLoc: languageDefInternal[] = [_locales()[0]];

            if (culture != null) {
                loc = locales.findItem(culture[1]);
            }

            if (!loc)
                loc = loadLoc[0];
            else if (loadLoc[0] !== loc)
                loadLoc.push(loc);


            locale(loc.locale);

            loadLoc.forEach(l => l.isLoaded = true);

            _globalizeInitMain = globalizeLoadSupplementals()
                .then(() => loadLanguage(loadLoc));

            _globalizeInitMsg = _globalizeInitMain.then(() => {
                Globalize.locale(loc.locale);
                localization.applyTranslationsStatic(document);
                localization.applyTranslationsDynamic(document);

                _globalizeChanged.subscribe(() => localization.applyTranslationsStatic(document));
            });

            return _globalizeInitMsg;
        }



        /**
         * Includes Messages to be loaded during initialization of globalize or loads them if globalize is already initialized
         * @param names Name of the Messages to load without extension
         */
        export function includeMessages(...names: Array<string | MessageDefinition>) {

            let names2: MessageDefinition[] = names.map(getMessageDefinition);

            names2 = names2.filter((msg, pos) => _messages.findIndex(findMessage(msg)) == -1 && names2.findIndex(findMessage(msg)) == pos);

            if (!names2 || !names2.length)
                return _messages.slice();

            if (!_globalizeInitMain) {
                _messages.push(...names2);
            }
            else {
                return _globalizeInitMsg.then(() => {
                    _messages.push(...names2);

                    return utils.all(...$.map(names2, n => loadMessages(n)))
                }).then(() => applyTranslationsStatic());
            }
        }

        function getMessagesFunc(msg: MessageDefinition) {
            if (msg != null) {

                let getFunc: (lang: languageDef) => PromiseLike<any> =
                    l => $.getJSON(utils.getUrl("Scripts/localization/{lang}/{name}.json", { lang: l.locale, name: msg.name }));

                switch (msg.type) {
                    case "api":
                        getFunc = l => $.getJSON(utils.getUrl("api/resource/{lang}/{name}", { lang: l.locale, name: msg.name }));
                        break;
                }

                return getFunc;
            }
        }


        async function loadMessagesCore(msgs: MessageDefinition[], langs: languageDef[]) {

            if (!msgs || !msgs.length || !langs || !langs.length)
                return;

            var reqArr = $.map(msgs, md => {
                let msgFunc = getMessagesFunc(md);
                return langs.map(l => msgFunc(l));
            });

            var resArr = await utils.allWithFails(...reqArr);

            resArr.forEach(Globalize.loadMessages);

            _globalizeChanged.valueHasMutated();
        }

        /**
         * Loads a Message File for all defined locales
         * @param name name of the messge without extension
         */
        export function loadMessages(name: MessageDefinition) {

            var msg = getMessageDefinition(name);

            if (msg != null) {
                return loadMessagesCore([msg], _locales().filter(l => l.isLoaded));
            }
        }

        /**
         * Loads a Message Files for all defined locales
         * @param name name of the messge without extension
         */
        function loadMessagesForLang(langs: languageDef[]) {
            return loadMessagesCore(_messages.slice(), langs);
        }

        /**
         * Loads a Message File for all defined locales
         * @param name name of the messge without extension
         */
        export function loadMessagesFromApi(name: string) {
            return includeMessages({ type: "api", name: name });
        }

        // #endregion

        // #region Translations

        /**
         * Get the errors thrown during localization of the ui
         */
        export function getErrors() {
            return errors;
        }

        /**
         * Clears the list of errors  thrown during localization of the ui
         */
        export function clearErrors() {
            errors = {};
        }

        /**
         * Get a message with the given id and parameters
         * @param id id of the message to get
         * @param params parameters for the message
         * @param errors object to store the errors e.g. if the message wasn't found
         */
        export function message(id: string, params?: any, errors?: localizationErrors) {
            try {
                return globalize().formatMessage(id, params)
            } catch (e) {
                addError(id, e, errors || getErrors());

                let tmp = id;
                if (id) {
                    let i2 = id.length - 1;

                    do {

                        let i = id.lastIndexOf("/", i2);

                        if (i != -1 && i + 1 < id.length) {
                            tmp = id.substr(i + 1, i2 - i);
                            i2 = i - 1;
                        }
                        else {
                            tmp = id;
                            break;
                        }
                    }
                    while (!tmp || tmp == "-" || tmp == "_" || tmp == ".");
                }

                if (tmp) {
                    tmp = tmp.replace(/[-_]\w/i, p => " " + p[1].toLocaleUpperCase());
                }

                return tmp;
            }
        }


        function translateElement(elm: Node, errors?: localizationErrors) {
            let $elm = $(elm);

            var langId: string = $elm.data("lang-id");

            if (typeof langId === "string" && langId) {
                var langArgs: any = $elm.data("lang-args");
                $elm.text(message(langId, langArgs, errors));
            }

            langId = $elm.data("lang-id-title");

            if (typeof langId === "string" && langId) {
                langArgs = $elm.data("lang-args-title");
                $elm.attr("title", message(langId, langArgs, errors));
            }
        }

        function translateNode(node: Node, errors?: localizationErrors) {

            if (!node || (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.DOCUMENT_NODE)) {
                return;
            }

            $(node).find("[data-lang-id], [data-lang-id-title]").addBack("[data-lang-id], [data-lang-id-title]")
                .each((i, elm) => translateElement(elm, errors));
        }

        function handleMutations(mutations: MutationRecord[], observer: MutationObserver) {
            let elms: Element[] = [];
            let nodes: Element[] = [];
            let rNodes: Element[] = [];

            function enumerateNodes(nodes: NodeList, func: (n: Node) => void) {
                if (nodes.forEach)
                    nodes.forEach(func);
                else
                    for (var i = 0; i < nodes.length; i++) {
                        func(nodes.item(i));
                    }
            }

            if (mutations)
                mutations.forEach(m => {
                    switch (m.type) {
                        case "attributes":
                            elms.push(<Element>m.target);
                        case "childList":
                            enumerateNodes(m.addedNodes, i => { if (i.nodeType == Node.ELEMENT_NODE) nodes.push(<Element>i); });
                            enumerateNodes(m.removedNodes, i => { if (i.nodeType == Node.ELEMENT_NODE) rNodes.push(<Element>i); });
                        default:
                    }
                });

            let uElms = $.uniqueSort(elms);
            let uNodes = $.uniqueSort(nodes);
            let uRNodes = $.uniqueSort(rNodes);

            let nodes2 = $.map(uNodes, n => {
                return uRNodes.indexOf(n) == -1 ? n : null;
            });

            uElms.forEach(elm => translateElement(elm));
            nodes2.forEach(node => translateNode(node));
        }

        function addError(langId: string, err: any, errors?: localizationErrors) {
            if (errors)
                if (!errors[langId])
                    errors[langId] = err;
                else {
                    let v = errors[langId];

                    if ($.isArray(v))
                        v.push(err);
                    else
                        errors[langId] = [v, err];
                }
        }

        /**
         * Applies the translation to an element (sets the Text content)
         * @param node Node to translate (needs to be an element)
         * @param langId Id of the message
         * @param langArgs Parameter for the message
         * @param errors object to store errors
         */
        export function applyTranslationElement(node: Node, langId: string, langArgs?: any, errors?: localizationErrors) {
            if (typeof langId === "string" && langId) {
                $(node).text(message(langId, langArgs, errors));
            }
        }

        /**
         * Applies the translation to an element (sets the Title Attribute)
         * @param node Node to translate (needs to be an element)
         * @param langId Id of the message
         * @param langArgs Parameter for the message
         * @param errors object to store errors
         */
        export function applyTranslationElementTitle(node: Node, langId: string, langArgs?: any, errors?: localizationErrors) {
            if (typeof langId === "string" && langId) {
                $(node).attr("title", message(langId, langArgs, errors));
            }
        }

        /**
         * Applies the translations to the descendends of an element (based on data-Attributes)
         * @param node Node Containing the Elements to Translate
         */
        export function applyTranslationsStatic(node?: Node) {
            let errors: localizationErrors = {};

            translateNode(node || document, errors);

            if (Object.keys(errors).length) {
                console.log(errors);
            }
        }

        /**
         * Attaches a MutationObserver that will update translations if the DOM changes
         * @param node Node to which the MutationObserver is attached
         */
        export function applyTranslationsDynamic(node?: Node) {
            let obs = new MutationObserver(handleMutations);

            node = node || document;

            obs.observe(node, {
                attributes: true,
                childList: true,
                subtree: true,
                attributeFilter: ["data-lang-id", "data-lang-args"]
            });

            applyTranslationsStatic(node);

            return obs;
        }

        // #endregion

        export var locale = ko.pureComputed<string>({
            read: _locale,
            write: function (value: string) {
                if (typeof value != "string" || utils.equalsIgnoreCase(value, _locale()))
                    return;

                let loc: languageDefInternal = locales.findItem(value);

                if (!loc)
                    throw "Not Supported Locale";

                if (moment)
                    moment.locale(loc.culture);

                _locale(loc.locale);

                if (_globalizeInitMain)
                    _globalizeInitMain.then(() => {
                        if (!loc.isLoaded) {
                            loc.isLoaded = true;
                            loadLanguage([loc]).then(() => {
                                clearErrors();
                                Globalize.locale(_locale());
                                _globalizeChanged.valueHasMutated();
                            });
                        }
                        else {
                            clearErrors();
                            Globalize.locale(_locale());
                            _globalizeChanged.valueHasMutated();
                        }
                    });

                utils.setCultureCookie(_cultureCookieName, loc.culture);
            }
        })

        export var locales: KnockoutDictionaryExtender<languageDef> = createDictionary(_locales, { key: "locale", isReadOnly: true });
    }

    /**
     * Shorthand for the localization.message Function
     * @param id id of the message to get
     * @param params parameters for the message
     * @param errors object to store the errors e.g. if the message wasn't found
     */
    export const t = localization.message;
    /**
     * Creates an computedObservable for a localized message
     * @param langId Language Id of the message, can be an observable
     * @param params parameters for the message
     * @param errors object to store the errors e.g. if the message wasn't found
     */
    export function t2(langId: ObservableOrValue<string>, params?: ObservableOrValue<any>, errors?: Dictionary<any>) {

        var res = ko.pureComputed(() => {
            var _langId = ko.unwrap(langId);
            var _params = ko.unwrap(params);

            (<any>res)._langId = _langId;

            return localization.message(_langId, _params, errors);
        })


        return res;
    }
    /**
     * Combines multiple (localized) texts
     * @param texts texts to combine, may be observables
     */
    export function t3(...texts: ObservableOrValueReadonly<string>[]): ObservableOrValueReadonly<string> {
        return combineTexts(null, ...texts);
    }
    type combineTextOptions = {
        // TODO Add Options
        separator: string
    }
    const defaultCombineTextOptions: combineTextOptions = {
        separator: " "
    }
    /**
     * Combines multiple (localized) texts
     * @param options options for combining Texts
     * @param texts texts to combine, may be observables
     */
    export function combineTexts(options: combineTextOptions, ...texts: ObservableOrValueReadonly<string>[]): ObservableOrValueReadonly<string> {
        if (!$.isArray(texts) || !texts.length)
            return "";

        if (!options)
            options = defaultCombineTextOptions;

        return ko.pureComputed(() => {
            var res = "";

            texts.forEach(txt => {
                txt = ko.unwrap(txt);
                if (txt) {
                    if (res && txt != ":") res += options.separator;
                    res += txt;
                }
            });

            return res;
        });
    }

    export var fileSources: IFileInputSource[] = []; // Q> make observable?
    export function getFileSources(options: FileInputSourceOptions) {
        var res: IFileInputSource[] = [];

        for (var i = 0; i < fileSources.length; i++) {
            var src2 = fileSources[i].prepare(options);
            if (src2)
                res.push(src2);
        }

        return res;
    }

    export const refHandlers = new (class RefHandlers {
        private readonly _handlers = ko.observableArray<IRefHandler>();

        addHandler(handler: IRefHandler) {
            if (handler)
                this._handlers.push(handler);
        }

        getHandler(name: string): IRefHandler {
            var res: IRefHandler = null;

            if (name) {
                var [name, sub] = name.split("/", 2);

                res = this._handlers().find(h => utils.equalsIgnoreCase(h.name, name));

                if (res && sub) {
                    var cmp = res as ICompositeRefHandler;
                    if (cmp.getSubHandler)
                        res = cmp.getSubHandler(sub);
                    else
                        res = null;
                }

            }


            return res;
        }

        getHandlers(...names: string[]): IRefHandler[] {
            var self = this;
            var res: IRefHandler[] = [];

            if (names)
                names.forEach(n => {
                    var tmp = self.getHandler(n);
                    if (tmp) res.push(tmp);
                })

            return res;
        }

        findHandler(refType: string): IRefHandler {
            var res: IRefHandler = null;

            if (refType)
                res = this._handlers().find(h => h.canHandle(refType));

            return res;
        }

        handlers = ko.pureComputed(() => {
            var hArr = this._handlers();

            return hArr.sort(compareHandlers);
        });

        getTempResult(ref: ITargetRef): ITargetSearchResult {
            if (!ref || !ref.refType || !ref.refId)
                return null;

            return {
                refId: ref.refId,
                refType: ref.refType,
                displayInfo: ref.refType + " " + ref.refId
            };
        }

    })();
    function compareHandlers(x: IRefHandler, y: IRefHandler): number {
        return utils.compareIgnoreCase(getName(x), getName(y));

        function getName(h: IRefHandler): string {
            return ko.unwrap(h.displayName) || h.name;
        }
    }

    interface TargetRefViewEventBase {
        readonly view: TargetRefView;
    }

    export interface TargetRefViewSearchCompleteEvent extends TargetRefViewEventBase {
        readonly result: ITargetSearchResult;

        cancel?: boolean;
    }

    interface TypeToTargetRefViewEventMap {
        searchCompleted: TargetRefViewSearchCompleteEvent
        //targetDeleted: TargetRefViewEventBase
    };
    type TargetRefViewEventHandler<TType extends keyof TypeToTargetRefViewEventMap> = (e: TypeToTargetRefViewEventMap[TType]) => void;

    export class TargetRefView {
        private _ref: ITargetRef;
        private _res = ko.observable<ITargetSearchResult>();
        private _load: PromiseLike<ITargetSearchResult>;
        private _evnts: { [type in keyof TypeToTargetRefViewEventMap]?: TargetRefViewEventHandler<type>[] } = {};

        constructor(readonly ref?: KnockoutObservable<ITargetRef>) {
            if (!ko.isWriteableObservable(ref))
                this.ref = ref = ko.observable();

            ref.subscribe(v => {
                if (v == this._ref) return;

                this._ref = v;
                this._res(refHandlers.getTempResult(v));
                this._load = null;

                if (v && v.refType) {
                    var h = refHandlers.findHandler(v.refType);
                    if (h) {
                        var p = this._load = h.resolveTarget(v);
                        p.then(r => {
                            if (p == this._load)
                                this._res(r)
                        });
                    }
                }


            })

        }


        // TODO Create generic base class for managing Event Handlers
        // Q> Events?
        on<TType extends keyof TypeToTargetRefViewEventMap>(evt: TType, handler: TargetRefViewEventHandler<TType>) {
            if (!evt || !handler) return;

            var hArr = this._evnts[evt] as TargetRefViewEventHandler<TType>[];
            if (!hArr)
                hArr = this._evnts[evt] = [];

            hArr.push(handler);
        }
        off<TType extends keyof TypeToTargetRefViewEventMap>(evt: TType, handler: (e: TypeToTargetRefViewEventMap[TType]) => void) {
            if (!evt || !handler) return;

            var hArr = this._evnts[evt] as TargetRefViewEventHandler<TType>[];
            if (!hArr) return;

            var ix = hArr.indexOf(handler);
            if (ix != -1)
                hArr.splice(ix, 1);
        }
        trigger<TType extends keyof TypeToTargetRefViewEventMap>(evt: TType, e: TypeToTargetRefViewEventMap[TType]) {
            if (!evt || !e) return;

            var hArr = this._evnts[evt] as TargetRefViewEventHandler<TType>[];
            if (!hArr) return;

            hArr.forEach(h => {
                h(e);
            });
        }

        setResult(res: ITargetSearchResult) {
            var ref: ITargetRef = null;
            if (res && res.refId)
                ref = { refType: res.refType, refId: res.refId };

            var e: TargetRefViewSearchCompleteEvent = { result: res, view: this };
            this.trigger("searchCompleted", e);
            if (e.cancel) return;


            this._ref = ref;
            this.ref(ref);
            this._load = null;
            this._res(res);
        }

        displayText = ko.pureComputed(() => {
            var res = ko.unwrap(this._res);
            return res ? ko.unwrap(res.displayInfo) : null;
        });

        wrapAction = (action: IRefSearchAction) => {
            var vm = this;

            var res: Mutable<IActionGroupDefinition> = {
                caption: action.displayName,
                icon: action.icon || "fa-search",
            }

            if (action.disable != null)
                res.disable = action.disable;
            if (action.search)
                res.click = async () => {
                    var res = await action.search();

                    vm.setResult(res);
                }
            else if (action.items)
                res.items = ko.pureComputed(() => {
                    return ko.unwrap(action.items).map(vm.wrapAction);
                });


            return res;
        }


    }

    //interface TargetRefCacheEntry {
    //    count: number;
    //    result: PromiseLike<ITargetSearchResult>;
    //}
    //class TargetRefCache {
    //    _entries: Dictionary<Dictionary<TargetRefCacheEntry>> = {};

    //    getDisplayInfo(ref: ITargetRef, handler?: IRefHandler): PromiseLike<ITargetSearchResult> {

    //        if (!ref || !ref.refType) return null;

    //        var entry = this._findEntry(ref);
    //        if (entry) {
    //            entry.count++;
    //            return entry.result;
    //        }

    //        entry = {
    //            count: 1,
    //            result: this._resolveEntry(ref, handler)
    //        }

    //        var dict = this._entries[ref.refType];
    //        if (!dict) dict = this._entries[ref.refType] = {};
    //        dict[ref.refId] = entry;




    //    }

    //    releaseDisplayInfo(ref: ITargetRef) {
    //        if (ref && typeof ref.refType == "string" && typeof ref.refId == "string") {

    //            var dict = this._entries[ref.refType];
    //            if (dict) {
    //                var entry = dict[ref.refId];
    //                entry.count--;
    //                if (entry.count <= 0)
    //                    delete dict[ref.refId];
    //            }
    //        }
    //    }

    //    private async _resolveEntry(ref: ITargetRef, handler: IRefHandler): Promise<ITargetSearchResult> {
    //        if (!handler || !handler.canHandle(ref.refType))
    //            handler = refHandlers.findHandler(ref.refType);

    //        var res: ITargetSearchResult = null;
    //        if (handler) {
    //            res = await handler.resolveTarget(ref);
    //        }
    //        if (!res)
    //            res = refHandlers.getTempResult(ref);

    //        return res;
    //    }

    //    private _findEntry(ref: ITargetRef): TargetRefCacheEntry {
    //        if (ref && typeof ref.refType == "string" && typeof ref.refId == "string") {
    //            var dict = this._entries[ref.refType];
    //            if (dict) {
    //                var entry = dict[ref.refId];
    //                return entry;
    //            }

    //        }
    //        return null;
    //    }

    //}

    // #region PropertyMapping
    type propVals = boolean | string | number | MappableObject;
    /** Property Definition as Tuple
     * Name of the Property
     * Default Value
     * (optional) Extenders?
     * */
    type propDefTuple<TViewModel, TKey extends keyof TViewModel> = [Extract<TKey, string>, propVals | { (): propVals; }, { [name: string]: any }?];
    type propDef<TViewModel, TKey extends keyof TViewModel> = Extract<TKey, string> | PropertyMappingDeclaration<TViewModel, TKey> | propDefTuple<TViewModel, TKey>

    /** Base Class for Implementing Property Mapping Handlers */
    export class DefaultPropertyMappingHandlerBase implements PropertyMapperHandler {

        /**
         * Returns the Defaultvalue from the Mapping Definition
         * @param prop
         */
        protected getDefaultValue<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>): unknown {
            return PropertyMapper.helper.getDefaultValue(prop);
        }

        /**
         * Converts the Value from the ViewModel-Type to the Model-Type
         * @param prop Definition of the Property Mapping
         * @param value Value to Convert
         */
        protected convertValueForViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, value: unknown): unknown {
            return value;
        }
        /**
         * Converts the Value from the Model-Type to the ViewModel-Type
         * @param prop Definition of the Property Mapping
         * @param value Value to Convert
         */
        protected convertValueForModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, value: unknown): unknown {
            return value;
        }

        /**
         * Reads the Value from the ViewModel
         * @param prop Definition of the Property Mapping
         * @param ctx Mapping Context for the Operation
         */
        protected readValueFromViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>): unknown {
            return ko.unwrap(ctx.instance[prop.name]);
        }

        /**
        * Writes the Value from the ViewModel
        * @param prop Definition of the Property Mapping
        * @param ctx Mapping Context for the Operation
        * @param value Converted Value to Write
        */
        protected writeValueToViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>, value: unknown): void {
            var vm = ctx.instance;

            if (vm[prop.name] === undefined)
                prop.handler.create(prop, ctx);

            if (ko.isWriteableObservable(vm[prop.name]))
                (<any>vm[prop.name])(value);
            else
                (<any>vm[prop.name]) = value;
        }

        /**
         * Reads the Value from the Model
         * @param prop Definition of the Property Mapping
         * @param ctx Mapping Context for the Operation
         */
        protected readValueFromModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, m: Partial<TModel>): unknown {
            return PropertyMapper.helper.getValue<TViewModel, TModel>(prop, m);
        }
        /**
        * Writes the Value from the Model
        * @param prop Definition of the Property Mapping
        * @param ctx Mapping Context for the Operation
        * @param value Converted Value to Write
        */
        protected writeValueToModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, m: Partial<TModel>, value: unknown): void {

            (<any>m[prop.srcName]) = value;
        }

        /**
         * Initializes/Creates a Mapped Property in the ViewModel
         * @param prop Definition of the Property Mapping
         * @param ctx Mapping Context for the Operation
         */
        create<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

            let value = this.getDefaultValue(prop);

            let obs = ko.observable(this.convertValueForViewModel(prop, value));

            if (prop.extend)
                obs = obs.extend(prop.extend);

            (<any>ctx.instance[prop.name]) = obs;
        }

        /**
         * Fills the Model Value for the Property from the ViewModel
         * @param prop Definition of the Property Mapping
         * @param ctx Mapping Context for the Operation
         */
        toModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
            let value = this.readValueFromViewModel(prop, ctx);

            value = this.convertValueForModel(prop, value);

            this.writeValueToModel(prop, ctx.model, value);
        };


        /**
         * Loads the Property Value for the ViewModel from the Model
         * @param prop Definition of the Property Mapping
         * @param ctx Mapping Context for the Operation
         */
        fromModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

            let value = this.readValueFromModel(prop, ctx.model);

            value = this.convertValueForViewModel(prop, value);

            this.writeValueToViewModel(prop, ctx, value);
        };
    }

    function getStagedContext(ctx: PropertyMappingContext<any, any>) {
        if (ctx.staged == null)
            ctx.staged = {
                isInitializing: ko.observable(true),
                observables: []
            }

        return ctx.staged;
    }

    class StagedPropertyMappingHandlerBase extends DefaultPropertyMappingHandlerBase {

        protected writeValueToViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>, value: propVals): void {
            var vm = ctx.instance;

            if (vm[prop.name] === undefined)
                prop.handler.create(prop, ctx);

            var pVal: unknown = vm[prop.name];

            if (utils.isStagedObservable(pVal))
                pVal.baseValue(value);
            else if (ko.isWriteableObservable(pVal))
                pVal(value);
            else
                (<any>vm[prop.name]) = value;
        }

        create<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

            let vm = ctx.instance;
            let value = this.getDefaultValue(prop);

            let obs = ko.observable(this.convertValueForViewModel(prop, value));

            var stOptions: utils.StagedObservableOptions<any> = { baseObservable: obs };

            var stCtx = getStagedContext(ctx);
            var isInit = stCtx.isInitializing;


            if (typeof prop.coerceValue === "function") {

                stOptions.coerceValue = v => {
                    if (isInit && isInit.peek()) {
                        isInit()
                        return v;
                    }
                    else isInit = null;

                    return prop.coerceValue.call(vm, v);
                };
            }

            let stObs = utils.stagedObservable(stOptions);
            stCtx.observables.push(stObs);

            //if (prop.extend)
            //    stObs = stObs.extend(prop.extend);

            (<any>vm[prop.name]) = stObs;
        }
    }

    class DatePropertyMappingHandler extends DefaultPropertyMappingHandlerBase {
        create<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

            var ext = prop.extend;
            if (!ext || typeof (ext) != "object")
                ext = {};
            if (!("date" in ext || "dateTime" in ext)) {
                if (prop.dateTime)
                    ext.dateTime = null;
                else
                    ext.date = prop.mode || null;
            }

            (<any>ctx.instance)[prop.name] = ko.observable(PropertyMapper.helper.getDefaultValue(prop)).extend(ext);
        }

        protected readValueFromViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>): unknown {

            let obs: KnockoutDateExtender = <any>ctx.instance[prop.name];
            if (ko.isObservable(obs) && obs.state)
                return obs.state().date();
            else
                return super.readValueFromViewModel(prop, ctx);
        }
        protected writeValueToViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>, value: unknown): void {
            var vm = ctx.instance;

            if (vm[prop.name] === undefined)
                prop.handler.create(prop, ctx);

            let obs: KnockoutDateExtender = <any>vm[prop.name];
            if (ko.isObservable(obs) && obs.state) {
                obs.state().value(<any>value);
            }
            else
                super.writeValueToViewModel(prop, ctx, value);
        }
    }

    class DurationPropertyMappingHandler extends DefaultPropertyMappingHandlerBase {
        create<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
            (<any>ctx.instance)[prop.name] = ko.observable(PropertyMapper.helper.getDefaultValue(prop)).extend({ timeSpan: null });
        }

        protected readValueFromViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>): unknown {

            let obs: KnockoutTimeSpanExtender = <any>ctx.instance[prop.name];
            if (ko.isObservable(obs) && obs.state)
                return obs.state().timeSpan();
            else
                return super.readValueFromViewModel(prop, ctx);
        }
        protected writeValueToViewModel<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>, value: unknown): void {
            var vm = ctx.instance;

            if (vm[prop.name] === undefined)
                prop.handler.create(prop, ctx);

            let obs: KnockoutTimeSpanExtender = <any>vm[prop.name];
            if (ko.isObservable(obs) && obs.state) {
                obs.state().value(<any>value);
            }
            else
                super.writeValueToViewModel(prop, ctx, value);
        }
    }

    /** Mapper for converting the State of a ViewModel into a Model and back */
    export class PropertyMapper<TViewModel, TModel = unknown, TKey extends keyof TViewModel = keyof TViewModel> {

        static helper = {

            getDefaultValue<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>) {
                let value: propVals = null;

                if (prop.value !== undefined)
                    if (typeof (prop.value) === "function")
                        value = (<any>prop.value)();
                    else
                        value = prop.value;

                return value;
            },

            getValue<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, model?: Partial<TModel>) {
                let value = undefined;

                if (model)
                    value = model[prop.srcName];

                if (value === undefined)
                    value = PropertyMapper.helper.getDefaultValue(prop);

                return value;
            },

            createBlock<TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, parent: MappableObject, model?: MappableObject) {
                let value: MappableBlock;

                if (typeof (prop.type) === "function")
                    value = new prop.type(parent, model);
                else {
                    //value = { parent: parent };
                    //if (model)
                    //    for (var key in model) {
                    //        value[key] = model[key];
                    //    }
                    if (model)
                        value = utils.copy(model);
                }

                return value
            },

            getPropHandler<TViewModel, TModel>(prop: PropertyMappingDeclaration<TViewModel>): PropertyMappingDefinition<TViewModel, TModel> {

                if (prop.handler === undefined) {
                    if (PropertyMapper.dateRegEx.test(prop.name))
                        prop.handler = PropertyMapper.handlers.date;
                    else
                        prop.handler = PropertyMapper.handlers.default;
                }
                else if (typeof (prop.handler) === "string") {
                    let handlerName = prop.handler as keyof PropertyMappingHandlers;

                    if (PropertyMapper.handlers[handlerName] !== undefined)
                        prop.handler = PropertyMapper.handlers[handlerName];
                    else
                        prop.handler = PropertyMapper.handlers.default;
                }
                else if (typeof (prop.handler) !== "object")
                    prop.handler = PropertyMapper.handlers.default;

                if (!prop.srcName)
                    prop.srcName = prop.name;

                return prop as PropertyMappingDefinition<TViewModel, TModel>;
            },

            importPropsFromModel<TViewModel, TModel>(props: PropertyMapper<TViewModel, TModel, any>, model: Partial<TModel>) {
                if (!model)
                    return;

                var propMappings: { [key: string]: PropertyMappingDefinition<TViewModel, TModel> } = {};
                var imports = Array<string>();

                props.props.forEach(p => propMappings[p.name] = p);

                for (var mProp in model) {
                    var value: any = model[mProp];

                    if (typeof mProp !== "string" || propMappings[mProp] || utils.startsWithIgnoreCase(mProp, "_")) {
                        continue;
                    }
                    else if (Array.isArray(value))
                        continue;
                    else if (typeof (value) === "object" && value) {
                        console.log(`Parameter:${mProp} is Object`, model, mProp, value);
                        continue;
                    }
                    else {
                        console.log(`Import Property: ${mProp}`)
                        props.addProp(<string>mProp as Extract<keyof TViewModel, string>);
                        imports.push(mProp);
                    }
                }

                if (imports.length !== 0)
                    console.log("Imported Properties:", imports);

            }

        }

        /** Regular Expression for identifying DateFields by convention */
        static dateRegEx = /date$/i;
        static handlers: PropertyMappingHandlers = {
            // Default Handler ( Value <=>  ObservableValue)
            default: new DefaultPropertyMappingHandlerBase(),
            // Handler for Dates ( Value <=> Observable (KnockoutDateExtender))
            date: new DatePropertyMappingHandler(),
            // Handler for TimeSpans/Durations ( Value <=> Observable (KnockoutTimeSpanExtender))
            duration: new DurationPropertyMappingHandler(),
            // Handler for Blocks/Objects ( Object <=> ViewModel)
            block: {
                create: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    (<any>ctx.instance)[prop.name] = PropertyMapper.helper.createBlock(prop, ctx.instance);
                },
                toModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let block: MappableBlock = ctx.instance[prop.name];
                    let result: MappableObject = null;

                    if (prop.toModel === undefined) {
                        if (block.toModel)
                            result = block.toModel();
                    }
                    else
                        result = prop.toModel(block);

                    (<any>ctx.model[prop.srcName]) = result;
                },
                fromModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    var vm = ctx.instance;

                    if (vm[prop.name] === undefined)
                        prop.handler.create(prop, ctx);

                    let block: MappableBlock = vm[prop.name];
                    let part: MappableObject = null;

                    if (ctx.model)
                        part = ctx.model[prop.srcName];

                    if (prop.fromModel === undefined) {
                        if (block.fromModel)
                            block.fromModel(part);
                    }
                    else
                        prop.fromModel(block, part);
                }
            },
            // Handler for Blocks/Objets as Observable ( Object <=> Observable<ViewModel>)
            valueBlock: {
                create: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    (<any>ctx.instance[prop.name]) = ko.observable(PropertyMapper.helper.getDefaultValue(prop));
                },
                toModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let block: MappableBlock = ko.unwrap(ctx.instance[prop.name]);
                    let result: any = null;

                    if (prop.toModel === undefined) {
                        if (block && block.toModel)
                            result = block.toModel();
                    }
                    else
                        result = prop.toModel(block);

                    ctx.model[prop.srcName] = result;
                },
                fromModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let vm = ctx.instance;
                    let block: MappableBlock = ko.unwrap(vm[prop.name]);
                    let part: MappableObject = null;

                    if (vm[prop.name] === undefined)
                        prop.handler.create(prop, ctx);


                    if (ctx.model)
                        part = ctx.model[prop.srcName];

                    if (prop.type)
                        block = part ? new prop.type(vm, part) : null;
                    else if (block) {
                        if (prop.fromModel === undefined) {
                            if (block.fromModel)
                                block.fromModel(part);
                        }
                        else
                            prop.fromModel(block, part);
                    }

                    if (ko.isWriteableObservable((<any>vm[prop.name])))
                        (<any>vm[prop.name])(block);
                    else
                        (<any>vm[prop.name]) = block;
                }
            },
            // Handler for List of Blocks/Objects ( Array<Object> <=> ObservableArray<ViewModel>)
            list: {
                create: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    (<any>ctx.instance)[prop.name] = ko.observableArray();
                },
                toModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let obs: KnockoutObservableArray<any> = (<any>ctx.instance[prop.name])

                    if (ctx.model)
                        (<any>ctx.model[prop.srcName]) = $.map(ko.unwrap(obs), function (item: MappableBlock) {
                            if (prop.toModel === undefined) {
                                if (item.toModel)
                                    return item.toModel();
                                else
                                    return utils.copy(item);
                            }
                            else
                                return prop.toModel(item);

                        });
                },
                fromModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let vm = ctx.instance;

                    if (vm[prop.name] === undefined)
                        prop.handler.create(prop, ctx);

                    var items: Array<MappableBlock> = [];

                    if (ctx.model && ctx.model[prop.srcName]) {
                        var mProp = ctx.model[prop.srcName];

                        if (Array.isArray(mProp))
                            mProp.forEach(function (item: MappableBlock) {
                                let value = PropertyMapper.helper.createBlock(prop, vm, item);

                                if (prop.fromModel !== undefined)
                                    prop.fromModel(vm, item);

                                if (value)
                                    items.push(value);
                            });
                    }

                    let vmProp: KnockoutObservableArray<MappableBlock> = (<any>vm[prop.name]);

                    if (ko.isWriteableObservable(vmProp))
                        vmProp(items);
                    else
                        (<any>vm[prop.name]) = items;

                }
            },
            // Handler for List of Values ( Array<Value> <=> ObservableArray<{value:Observable}>)
            valueList: {
                create: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    (<any>ctx.instance[prop.name]) = ko.observableArray();
                },
                toModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let obs: KnockoutObservableArray<{ value: ObservableOrValue<string | number | boolean | object> }> = (<any>ctx.instance[prop.name])

                    if (ctx.model)
                        (<any>ctx.model[prop.srcName]) = $.map(ko.unwrap(obs), function (item: { value: ObservableOrValue<any> }) {
                            return ko.unwrap(item.value);
                        });
                    else
                        ctx.model[prop.srcName] = null;
                },
                fromModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let vm = ctx.instance;

                    if (vm[prop.name] === undefined)
                        prop.handler.create(prop, ctx);

                    var items: Array<{ value: ObservableOrValue<string | number | boolean | object> }> = [];

                    if (ctx.model && ctx.model[prop.srcName]) {
                        var mProp = ctx.model[prop.srcName];

                        if (Array.isArray(mProp))
                            mProp.forEach(function (item: string | number | boolean | object) {
                                items.push({ value: ko.observable(item) });
                            });
                    }
                    else {
                        var def = PropertyMapper.helper.getDefaultValue(prop);
                        if (def !== undefined)
                            items.push({ value: ko.observable(def) });
                    }

                    let vmProp: KnockoutObservableArray<string | number | boolean | object> = <any>vm[prop.name];

                    if (vmProp)
                        vmProp(items);
                    else
                        (<any>vm[prop.name]) = items;

                }
            },

            // Handler that ignores Properties (so they don't get Imported from the Model?)
            ignore: {
                create: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

                },
                toModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

                },
                fromModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

                }
            },

            model: {
                create: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

                    let obs = ko.observable();

                    if (prop.extend)
                        obs = obs.extend(prop.extend);

                    (<any>ctx.instance)[prop.name] = obs;
                },
                toModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    ctx.originalModel = ko.unwrap(ctx.instance[prop.name]);

                    utils.extend2(ctx.model, ctx.originalModel);
                },
                fromModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    let vm = ctx.instance;
                    let value = ctx.model;

                    if (vm[prop.name] === undefined)
                        prop.handler.create(prop, ctx);

                    let vmProp: KnockoutObservable<any> = <any>vm[prop.name];

                    if (ko.isWriteableObservable(vmProp))
                        vmProp(value);
                    else
                        (<any>vm[prop.name]) = value;
                }
            },

            staged: new StagedPropertyMappingHandlerBase(),
            stagedIsChanged: {
                create: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {
                    var stCtx = getStagedContext(ctx);

                    var obs = stCtx.observables;

                    (<any>ctx.instance)[prop.name] = ko.pureComputed(() => obs.some(o => o.isChanged()));

                },
                toModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

                },
                fromModel: function <TViewModel, TModel>(prop: PropertyMappingDefinition<TViewModel, TModel>, ctx: PropertyMappingContext<TViewModel, TModel>) {

                }
            }
        };

        private props: PropertyMappingDefinition<TViewModel, TModel>[];
        private events: Dictionary<{ (ctx: PropertyMappingContext<TViewModel, TModel>): void }[]> = {};

        constructor(props: Array<propDef<TViewModel, TKey>>, private importProps?: boolean) {
            let self = this;
            this.props = Array();

            props.forEach(function (prop) {
                self.addProp(prop);
            });

            if (importProps)
                console.warn("PropertyMapper.importProps is Deprecated use a Model-Handler for preserving undefined Properties instead");
        }

        private createContext(vm: TViewModel, model?: Partial<TModel>): PropertyMappingContext<TViewModel, TModel> {
            return { mapper: this, instance: vm, model: model };
        }

        public addModelProp() {
            if (!this.props.some(p => p.handler == PropertyMapper.handlers.model))
                this.props.unshift({
                    name: "_model" as any,
                    handler: PropertyMapper.handlers.model
                });

            return this;
        }

        /**
         * Copies PropertyMappings from another Mapper instance
         * @param mapper
         */
        public addFromParentMapper(mapper: PropertyMapper<any, any, any>) {
            if (mapper != null) {

                var curProps: { [key: string]: PropertyMappingDefinition<TViewModel, TModel> } = {};
                $.each(this.props, (i, p) => curProps[p.name] = p);

                mapper.props.forEach(p => {
                    if (curProps[p.name] === undefined)
                        this.props.push(<any>p);
                })
            }
            return this;
        }

        /**
         * Creates a new Mapper that inherits Mappings from this Mapper
         * @param props Additional Mappings for the new Mapper
         */
        public createChildMapper<TChildViewModel extends TViewModel, TChildModel extends TModel = TModel>(...props: Array<propDef<TChildViewModel, Exclude<keyof TChildViewModel, keyof TViewModel>>>) {
            var mapper = new PropertyMapper<TChildViewModel, TChildModel>(props, this.importProps);

            mapper.addFromParentMapper(<any>this);

            return mapper;
        }

        /**
         * Adds a Mapping for an Property
         * @param prop Definition of the Property
         */
        public addProp(prop: propDef<TViewModel, TKey>) {
            if (typeof (prop) === "string") {
                prop = { name: prop, handler: undefined };
            }
            else if ($.isArray(prop)) {
                let arr = prop;

                prop = { name: arr[0], handler: undefined, value: arr[1], extend: arr[2] };
            }

            this.props.push(PropertyMapper.helper.getPropHandler(prop as PropertyMappingDeclaration<TViewModel>));


            return this;
        }

        // TODO create on/off Functions for Registering Eventhandlers
        public on(name: PropertyMappingEventNames, handler: PropertyMappingEventHandler<TViewModel, TModel>) {
            if (!handler) return;

            var hArr = this.events[name];
            if (!hArr) hArr = this.events[name] = [];

            hArr.push(handler);
        }
        public off(name: PropertyMappingEventNames, handler: PropertyMappingEventHandler<TViewModel, TModel>) {

            var hArr = this.events[name];
            if (!hArr) return;

            if (!handler) delete this.events[name];
            else {
                var ix = hArr.indexOf(handler);
                hArr.splice(ix, 1);
            }
        }
        private raise(name: PropertyMappingEventNames, ctx: PropertyMappingContext<TViewModel, TModel>) {
            var hArr = this.events[name];
            if (!hArr) return;

            for (var i = 0; i < hArr.length; i++) {
                hArr[i](ctx);
            }

        }

        /**
         * Initializes (creates) the mapped Properties for a new Instance
         * @param vm Newly created ViewModel
         */
        public create(vm: TViewModel) {

            var ctx = this.createContext(vm);

            this.props.forEach(function (prop) {
                if (prop.handler && prop.handler.create)
                    prop.handler.create(prop, ctx);
                else
                    PropertyMapper.handlers.default.create(prop, ctx);
            });

            if (ctx.staged) {
                ctx.staged.isInitializing(false);
            }

            this.raise("created", ctx);
        };

        /**
         * Fills the Model with the Values of the Mapped Properties
         * @param vm
         * @param model Instance of the (empty) Model to fill
         */
        public toModel(vm: TViewModel, model: Partial<TModel>) {
            if (typeof (model) === "object") {
                var ctx = this.createContext(vm, model);
                this.props.forEach(function (prop) {
                    if (prop.handler && prop.handler.toModel)
                        prop.handler.toModel(prop, ctx);
                    else
                        PropertyMapper.handlers.default.toModel(prop, ctx);
                });

                // Q> Extend with properties from original Model?
                //    Default Behaviour
                //    Configuration for this Behaviour? (Conditions, excluded Fields, ...)
                //
                //if (ctx.originalModel)
                //    utils.extend2(model, ctx.originalModel);


            }
        };

        /**
         * Sets the Mapped properties to the values from the Model
         * @param vm Instance of the ViewModel
         * @param model Instance of the Model
         */
        public fromModel(vm: TViewModel, model: Partial<TModel>) {
            var ctx = this.createContext(vm, model);

            if (this.importProps && model) {
                PropertyMapper.helper.importPropsFromModel<TViewModel, TModel>(this, model);
                this.importProps = false;
            }

            this.props.forEach(function (prop) {
                if (prop.handler && prop.handler.fromModel)
                    prop.handler.fromModel(prop, ctx);
                else
                    PropertyMapper.handlers.default.fromModel(prop, ctx);
            });

            this.raise("loaded", ctx);
        }
    }

    /** Definition used to Declare a Mapping */
    export interface PropertyMappingDeclaration<TViewModel, TKey extends keyof TViewModel = keyof TViewModel, TModel = MappableObject> {
        name: Extract<TKey, string>;
        srcName?: keyof TModel;
        handler?: PropertyMapperHandler | keyof PropertyMappingHandlers;
        type?: { new(parent: MappableBlock, model?: MappableObject): MappableBlock; }
        value?: propVals | { (): propVals; };
        toModel?(block: MappableBlock): MappableObject;
        fromModel?(block: MappableBlock, model?: MappableObject): void;
        [key: string]: any;
    }

    // Definition of a Mapped Property
    export interface PropertyMappingDefinition<TViewModel, TModel> {
        name: Extract<keyof TViewModel, string>;
        srcName?: Extract<keyof TModel, string>;
        handler: PropertyMapperHandler;
        type?: { new(parent: MappableBlock, model?: MappableObject): MappableBlock; }
        value?: propVals | { (): propVals; };
        toModel?(block: MappableBlock): MappableObject;
        fromModel?(block: Partial<MappableBlock>, model?: MappableObject): void;
        [key: string]: any;
    }

    export interface PropertyMappingContext<TViewModel, TModel> {
        mapper: PropertyMapper<TViewModel, TModel, any>;
        instance: TViewModel;
        model?: Partial<TModel>;
        originalModel?: Partial<TModel>;

        staged?: {
            isInitializing: KnockoutObservable<boolean>;
            observables: utils.StagedObservable<any>[]
        }
    }

    // Q> Create Mapped Types for EventHandling
    export type PropertyMappingEventNames = "created" | "loaded";
    export type PropertyMappingEventHandler<TViewModel, TModel> = (ctx: PropertyMappingContext<TViewModel, TModel>) => void;

    export interface PropertyMappingHandlers {

        /** Default Handler ( Value <=>  ObservableValue)*/
        default: PropertyMapperHandler;
        /** Handler for Dates ( Value <=> Observable (KnockoutDateExtender)) */
        date: PropertyMapperHandler;
        /** Handler for TimeSpans/Durations ( Value <=> Observable (KnockoutTimeSpanExtender)) */
        duration: PropertyMapperHandler;
        /** Handler for Blocks/Objects ( Object <=> ViewModel) */
        block: PropertyMapperHandler;
        /** Handler for Blocks/Objets as Observable ( Object <=> Observable<ViewModel>) */
        valueBlock: PropertyMapperHandler;
        /** Handler for List of Blocks/Objects ( Array<Object> <=> ObservableArray<ViewModel>) */
        list: PropertyMapperHandler;
        /** Handler for List of Values ( Array<Value> <=> ObservableArray<{value:Observable}>) */
        valueList: PropertyMapperHandler;

        /** Handler that ignores Properties (so they don't get Imported from the Model?) */
        ignore: PropertyMapperHandler;

        /** Handler that stores a Copy of the Model */
        model: PropertyMapperHandler;
        /** Default Handler ( Value <=>  StagedObservable)*/
        staged: PropertyMapperHandler;
        stagedIsChanged: PropertyMapperHandler;
    }

    export interface PropertyMapperHandler<TVM = any, TM = any> {
        create: (prop: PropertyMappingDefinition<TVM, TM>, ctx: PropertyMappingContext<TVM, TM>) => void;
        toModel: (prop: PropertyMappingDefinition<TVM, TM>, ctx: PropertyMappingContext<TVM, TM>) => void;
        fromModel: (prop: PropertyMappingDefinition<TVM, TM>, ctx: PropertyMappingContext<TVM, TM>) => void;
    }
    // #endregion
}

// #region PolyFills

interface Array<T> {
    find(predicate: (value: T, index: number, array: Array<T>) => boolean): T;
    findIndex(predicate: (value: T, index?: number, array?: Array<T>) => boolean, thisValue?: any): number;
}

interface String {
    endsWith(search: string, position?: number): boolean;
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function <T>(predicate: (value: T, index: number, array: Array<T>) => boolean) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        }
    });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate: (value: any, index?: number, array?: Array<any>) => boolean) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        }
    });
}

// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith#Polyfill
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString: string, position?: number) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
    Object.keys = (function () {
        'use strict';
        var hasOwnProperty = Object.prototype.hasOwnProperty,
            hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
            dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ],
            dontEnumsLength = dontEnums.length;

        return function (obj: Object) {
            if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
                throw new TypeError('Object.keys called on non-object');
            }

            var result = [], prop, i;

            for (prop in obj) {
                if (hasOwnProperty.call(obj, prop)) {
                    result.push(prop);
                }
            }

            if (hasDontEnumBug) {
                for (i = 0; i < dontEnumsLength; i++) {
                    if (hasOwnProperty.call(obj, dontEnums[i])) {
                        result.push(dontEnums[i]);
                    }
                }
            }
            return result;
        };
    }());
}
// #endregion